/**
 * Centralized configuration for the demo package.
 *
 * All Firebase values come from VITE_FIREBASE_* env vars (set in .env.staging / .env.production).
 * Local dev uses .env.development which omits Firebase (the demo widget connects via API, not Firebase SDK directly).
 */

export const config = {
  apiUrl: (import.meta.env.VITE_API_BASE_URL || 'http://localhost:3003').replace(
    /\/$/,
    '',
  ),

  widgetUrl: (() => {
    const env = import.meta.env.VITE_WIDGET_URL as string | undefined;
    if (env) return env.replace(/\/$/, '');
    if (typeof window !== 'undefined') {
      const { hostname } = window.location;
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://localhost:5176';
      }
      // Local Caddy dev (*.dev.lasoxp.com) → use local widget dev server via Caddy
      if (hostname.endsWith('.dev.lasoxp.com')) {
        return 'https://widget.dev.lasoxp.com';
      }
    }
    return 'https://widget.agent.stage.lasoxp.com';
  })(),

  wsUrl: (() => {
    const apiUrl = (
      import.meta.env.VITE_API_BASE_URL || 'http://localhost:3003'
    ).replace(/\/$/, '');
    return apiUrl.startsWith('https')
      ? apiUrl.replace(/^https/, 'wss')
      : apiUrl.replace(/^http/, 'ws');
  })(),

  signupUrl: import.meta.env.VITE_SIGNUP_URL || 'https://lasoxp.com/contact',

  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
  },
};
